import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header  from './Header'
import ToastContainer from '../ui/Toast'

export default function AppLayout() {
  return (
    <div className="flex h-full min-h-screen bg-slate-50">
      <Sidebar />

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header />

        <main className="flex-1 overflow-y-auto scrollbar-thin">
          <div className="max-w-7xl mx-auto px-6 py-8">
            <Outlet />
          </div>
        </main>
      </div>

      <ToastContainer />
    </div>
  )
}
